import { Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";
import { useSubscription } from "@/context/SubscriptionContext";

// Wraps premium content: shows a blurred preview + upgrade CTA for free users.
export default function ProLock({ children, title, testid }) {
  const { t } = useI18n();
  const { isPro, openPaywall } = useSubscription();

  if (isPro) return children;

  return (
    <div className="relative rounded-2xl overflow-hidden" data-testid={testid || "pro-lock"}>
      <div className="pointer-events-none select-none blur-[6px] opacity-40 max-h-[320px] overflow-hidden">
        {children}
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-background/70 p-6 text-center">
        <div className="h-12 w-12 rounded-xl bg-secondary flex items-center justify-center">
          <Lock className="h-5 w-5 text-primary" />
        </div>
        <div>
          <p className="font-display font-bold text-lg">{title || t("unlock")}</p>
          <p className="text-sm text-muted-foreground mt-0.5">{t("proFeatures")}</p>
        </div>
        <Button data-testid="prolock-upgrade-btn" onClick={openPaywall} className="h-11 px-6 font-semibold">
          <Sparkles className="h-4 w-4 mr-1.5" /> {t("unlock")}
        </Button>
      </div>
    </div>
  );
}
